interface Slot {
  startTime: string;
  endTime: string;
}

type SlotGroup = Record<string, Slot[]>;

export const sortAvailabilityGroup = (slotGroups: SlotGroup) => {
  return Object.keys(slotGroups)
    .sort((a, b) => new Date(a).getDate() - new Date(b).getDate())
    .reduce((acc: SlotGroup, key) => {
      acc[key] = slotGroups[key];
      return acc;
    }, {});
};

export const sortAvailabilitySlots = (slots: Slot[]) => {
  return slots.sort(
    (a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime()
  );
};
